import React, { Component } from 'react'

class Close extends React.Component {

  render() {
    return (
      <div className="close__button--wrap">
        <button onClick={this.props.clickHandler} className="close__button">
          <div className="close__button--text">Close</div>
          <svg enable-background="new 0 0 12 12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
            <path d="m7.21 6 4.54-4.54c.33-.33.33-.88 0-1.21s-.88-.33-1.21 0l-4.54 4.54-4.54-4.54c-.33-.33-.88-.33-1.21 0s-.33.88 0 1.21l4.54 4.54-4.54 4.54c-.33.33-.33.88 0 1.21.17.17.39.25.61.25s.44-.08.61-.25l4.53-4.54 4.54 4.54c.16.17.38.25.6.25s.44-.08.61-.25c.33-.33.33-.88 0-1.21z" className="close__button--image" />
          </svg>
        </button>
      </div>
    );
  }
}

export default Close


// WEBPACK FOOTER //
// ./src/scripts/components/Close.js